module.exports = __webpack_public_path__ + "static/sheds-app-2216c001ff231eee4811b4fefc50a102.jpg";